// extracted by mini-css-extract-plugin
module.exports = {"Page":"PageLayout_Page__2iNe3","Screen":"PageLayout_Screen__2_-kj"};